/**
 * Card extraction uses paid totals and line descriptions; the shared review
 * form expects expense-account fields. Adapt a copy without changing the
 * receipt, using bank amounts, or replacing values already saved by review.
 */
export function cardReceiptForReview(receipt) {
  const json = receipt.json || {};
  const reviewJson = { ...json };
  if (json.UnadjustedTotal == null || json.UnadjustedTotal === '') {
    if (json.BigTotalPayed != null && json.BigTotalPayed !== '') {
      reviewJson.UnadjustedTotal = json.BigTotalPayed;
    } else if (json.TotalWithTax != null && json.TotalWithTax !== '') {
      const total = Number(json.TotalWithTax);
      const tip = Number(json.Tip || 0);
      if (Number.isFinite(total) && Number.isFinite(tip)) {
        reviewJson.UnadjustedTotal = total + tip;
      }
    }
  }
  // An explicitly saved empty narrative is intentional; only fill absent fields.
  if (json.Narrative == null) {
    reviewJson.Narrative = json.Description || (json.ListItem || [])
      .map(item => item.Description).filter(Boolean).join('\n');
  }
  return { ...receipt, json: reviewJson };
}
